export const environment = {
  production: true,
  TDS_URL: window.location.protocol + '//' + window.location.hostname,
  oAuthEnabled: true,
  testUserName: '',
  testUserPassword: '',
  programBrochureAssetsFolder: '_assets/angular/program_brochure/assets/',
  programWizardAssetsFolder: '_assets/angular/program_wizard/assets/',
  programTemplateAssetsFolder: '_assets/angular/program_template/assets/',
  programDiscoveryAssetsFolder: '_assets/angular/program_discovery/assets/',
  assetsFolder: '_assets/angular/program_discovery/assets/',
  googleAPIKey: 'AIzaSyCCGe0at0uAoc8aq2jYkUsStstYZgCTCGI',  
  environmentTimeZone: 'America/New_York',
  environmentTimeZoneOffset: '+00:00',
  APIV2_URL: 'https://dev-tasks-api.terradotta.com/',
  SETTINGS_URL: 'https://dev-tasks-api.terradotta.com/global-settings-api/',
  APPLICATION_URL: 'https://dev-tasks-api.terradotta.com/application-api/',
  PROCESS_ELEMENTS_URL: 'https://dev-tasks-api.terradotta.com/process-elements-api/',
  FILE_URL: 'https://dev-tasks-api.terradotta.com/file-api/',
  PROGRAM_URL: 'https://dev-tasks-api.terradotta.com/program-api/'
};
